import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { PermissaoAppRoutingModule } from "./permissao.app-routing.module";

@NgModule({
    imports: [
        CommonModule,
        PermissaoAppRoutingModule
    ]
})
export class PermissaoAppModule { }
